import Currencies from 'arbitrip-common/general/utils/Currencies'
export default Currencies;
